import { render, staticRenderFns } from "./lrList.vue?vue&type=template&id=37e38c5b&"
import script from "./lrList.vue?vue&type=script&lang=js&"
export * from "./lrList.vue?vue&type=script&lang=js&"
import style0 from "./lrList.vue?vue&type=style&index=0&id=37e38c5b&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports